import NameValueView from "../../attribute/NameValueView.js";
const comparators = new NameValueView('AttributeConditionComparator', {
  handleKey: 'canEdit',
  nameKey: 'attrName',
  multiple: true
});
export default {
  getComparatorsFor: comparators.getItemFor
};